<ng-container *ngIf="content">
  <ng-container *ngIf="showContent">
    <div *ngIf="content.preTitle" edsRow>
      <div edsCol>
        <p class="pre-title" edsSpacing="xs">{{ content.preTitle }}</p>
      </div>
    </div>
    <!--Title  -->
    <div *ngIf="content.title" edsRow>
      <eds-title
        edsSpacing="md"
        edsCol
        [isLight]="true"
        [title]="content.title"
        [size]="'h3'"
        theme="dark"
      ></eds-title>
    </div>
    <div *ngIf="content.summary" edsRow [edsSpacing]="showCta ? 'lg' : 'none'">
      <div edsCol>
        <!-- TODO: CHANGE TO DIV -->
        <p
          *ngIf="content.summary"
          class="large"
          [innerHTML]="content.summary"
        ></p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showCta && content.link?.displayText">
    <ng-container *ngTemplateOutlet="cta"></ng-container>
  </ng-container>

  <!-- Display CTA Button -->
  <ng-template #cta>
    <div edsRow edsPadding edsPaddingTop="lg">
      <div edsCol>
        <a
          edsButton="emphasis"
          [href]="content.link.url"
          [target]="content.link.target"
          [title]="content.link.title"
          [ngClass]="{ 'external-link': content.link.external }"
        >
          {{ content.link.displayText }}
        </a>
      </div>
    </div>
  </ng-template>
  <!-- / Display CTA Button -->
</ng-container>
